var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoElementinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 95"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3C4CFC",
    clipPath: "url(#logo-element_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.63 69.34H44.1v25.63H25.37V69.34H0v-18.8h25.37V25.05H44.1v25.47h25.53v18.8zM120 0H94.47v25.5H120V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-element_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v94.97H0z"
  })))));
}

export default SvgLogoElementinline;